module.exports = __webpack_public_path__ + "img/background.5ea713b1.png";